import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 51137 34321"
    {...props}
  >
    <path
      d="M50766 2828c0-725-318-1441-929-1925-1063-844-2607-666-3451 398L25568 27542 4751 1301C3906 239 2363 60 1300 903 236 1746 59 3290 902 4353l22742 28667c466 587 1175 930 1924 930s1459-343 1925-930L50235 4353c358-452 531-991 531-1525z"
      style={{
        fill: "#2b2a29",
        stroke: "#2b2a29",
        strokeWidth: 741.126,
      }}
      className="fill stroke1"
    />
  </svg>
)
export default SvgComponent
